<template>
    <v-dialog fullscreen :value="value" persistent>
        <chat-block :number="value ? number : ''" @close="$emit('input')"/>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: Boolean,
        number: String,
    },
    components: {
        chatBlock: () => import("./chatBlock.vue"),
    }
}
</script>

<style lang="scss">

.v-dialog.v-dialog--active.v-dialog--fullscreen {
    margin: auto !important;
    max-width: 600px;
    right: 0;
}
</style>